// Thank you form data which is common for all forms
const thankyouformdata = {
  demoFormThankYouImage: false,
  sendFeedbackThankYouImage: false,
  thankYouImage: true, // Boolean to decide which thank you modal should be displayed
  // variable used in thank you modal for showing thankyou message (default message)
  successMessageTitle: 'Thank you for your interest in Fyle!',
  successMessage: 'Sit back and relax. Our Customer Success team will soon reach out to you and set up a call.',
};

const formSuccessMessages = {
  partnerMessage: 'Sit back and relax. Our Customer Success team will soon reach out to you and set up a call.',
  cocpaFormSuccessMessage: 'Our partner team will soon reach out to you and set up a call.',
  demoFormSuccessMessage: 'Our sales team will contact you within the next 40 minutes to schedule a detailed demo.',
  idcMessage: 'Thank you for downloading! You should receive an email with a copy of IDC report.',
  downloadFeatureMessage: 'Thank you for downloading! You should receive an email with a copy of Fyle’s feature list.',
  sendFeedBack: 'Thank you for submitting your feedback',
  partnerReferralTitle: 'Thank you for your interest in partnering with Fyle!',
  partnerReferralMessage: 'Our partnerships team will contact you within the next 24 hours to schedule a call.',
  exitIntentDemoFormSuccessMessage: 'Our sales team will contact you within the next 40 minutes to schedule a detailed demo and help you claim your offer.',
  bakerTillyWebinarFormSuccessMessageTitle: 'Thank you for your interest in the webinar!',
  bakerTillyWebinarFormSuccessMessage: 'You will receive an invite shortly.',
};

const formIdsMap = {
  contentDownloadForm: '#content-download-form',
  contentDownloadFormWithDemo: '#contact-us-modal-demo-content-form',
  contentDownloadFormAllFeatures: '#content-download-form-feature-download',
  contentDownloadOutsideModal: '#content-download-form-outside-modal',
  contactUsForm: '#contact-us-form',
  contactUsFormOutsideModal: '#contact-us-form-outside-modal',
  contactUsFormExitIntentModal: '#contact-us-form-exit-intent-modal',
  sendFeedBack: '#send-feedback',
  contactUsFormFeatureDownload: '#contact-us-form-feature-download',
  partnerReferralForm: '#partners-referral-form',
  mncpaForm: '#contact-us-form--minnesota',
  cocpaForm: '#contact-us-form--colorado',
  alabamaForm: '#contact-us-form--alabama',
  floridaForm: '#contact-us-form--florida',
  accountingFirmsForm: '#accounting-firms-form',
  bakerTillyWebinarForm: '#baker-tilly-webinar',
  contentDownloadReportForm: '#content-download-form-report-download',
};

const hubspotFormIdMap = {
  feedbackForm: '2149d653-c8aa-44f1-9556-699ab188620c',
  startSignupForm: 'ee6e6d02-4ca0-43f3-b028-17770ab06302',
  masterForm: '387a882f-2466-45fa-ac6f-c7a87c708e0a',
  accountingFirmsForm: 'e30d6c53-16c9-4fec-9622-b6f0bde2d9b2',
  contentDownloadForm: 'fd6fb9be-65a6-4db2-81b5-f790eced119c',
  contentDownloadFormWithDemo: '2092195a-f79c-463b-baeb-9c8604212434',
  contentDownloadFormAllFeatures: 'fd6fb9be-65a6-4db2-81b5-f790eced119c',
  partnersReferralForm: 'f851341f-544d-4d40-ab81-bb3ca5a7038f',
  contactUsFormExitIntentModal: 'd93fba26-a3d5-4e01-a705-aead8a95053e',
  minnesotaCocpaFormHubspotId : 'a6b5a058-f812-42cf-b8c9-4fb25b696de5',
  coloradoCocpaFormHubspotId: '95690dae-a27e-4e91-84b0-215fdfdbc82d',
  alabamaCocpaFormHubspotId: 'd1c3646d-a0a7-4512-962f-4306fb25b0eb',
  floridaCocpaFormHubspotId: '88e174c8-12a8-4dda-8a61-512c1721f23b',
  bakerTillyWebinarFormHubspotId: '959c6c3d-613a-4cb2-aafd-b81d9fb77d18',
  contentDownloadReportFormHubspotId: 'f31cd2af-be5f-420d-8aee-f3b51304d8dd',
};

/* eslint-disable max-len */
const integrationUrls = {
  '/product/integrations/sage-intacct-accounting-software': 'https://3906991.fs1.hubspotusercontent-na1.net/hubfs/3906991/White%20papers/Fyle%20%2B%20Sage%20Intacct%20Integration.pdf',
  '/product/integrations/quickbooks-online-accounting-software': 'https://3906991.fs1.hubspotusercontent-na1.net/hubfs/3906991/Integration%20docs/Fyle%20%2B%20QBO%20detailed%20doc%20-%20Oct%202023.pdf',
  '/quickbooks-expense-tracking': 'https://3906991.fs1.hubspotusercontent-na1.net/hubfs/3906991/Integration%20docs/Fyle%20%2B%20QBO%20detailed%20doc%20-%20Oct%202023.pdf',
  '/quickbooks-integration': 'https://3906991.fs1.hubspotusercontent-na1.net/hubfs/3906991/Integration%20docs/Fyle%20%2B%20QBO%20detailed%20doc%20-%20Oct%202023.pdf',
};
/* eslint-enable max-len */

const formIdMap = {
  'send-feedback': hubspotFormIdMap.feedbackForm,
  'start-signup-form': hubspotFormIdMap.startSignupForm,
  'contact-us-form': hubspotFormIdMap.masterForm,
  'contact-us-form-outside-modal': hubspotFormIdMap.masterForm,
  'content-download-form': hubspotFormIdMap.contentDownloadForm,
  'contact-us-modal-demo-content-form': hubspotFormIdMap.contentDownloadFormWithDemo,
  'partners-referral-form': hubspotFormIdMap.partnersReferralForm,
  'content-download-form-feature-download': hubspotFormIdMap.contentDownloadFormAllFeatures,
  'content-download-form-outside-modal': hubspotFormIdMap.contentDownloadForm,
  'contact-us-form-exit-intent-modal': hubspotFormIdMap.contactUsFormExitIntentModal,
  'contact-us-form--minnesota': hubspotFormIdMap.minnesotaCocpaFormHubspotId,
  'contact-us-form--colorado': hubspotFormIdMap.coloradoCocpaFormHubspotId,
  'contact-us-form--florida': hubspotFormIdMap.floridaCocpaFormHubspotId,
  'contact-us-form--alabama': hubspotFormIdMap.alabamaCocpaFormHubspotId,
  'accounting-firms-form': hubspotFormIdMap.accountingFirmsForm,
  'baker-tilly-webinar': hubspotFormIdMap.bakerTillyWebinarFormHubspotId,
  'content-download-form-report-download': hubspotFormIdMap.contentDownloadReportFormHubspotId,
};

export {
  thankyouformdata,
  formSuccessMessages,
  formIdsMap,
  hubspotFormIdMap,
  integrationUrls,
  formIdMap
};